/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Lawyer { 
    additional_info?: object;
    auth_token?: string;
    changed_pw?: boolean;
    first_name?: string;
    full_name?: string;
    id?: string;
    is_technical?: boolean;
    last_name?: string;
    mail?: string;
}

